import React from "react";
import { Formik, Form } from "formik";
import { FormikFormGroup, ModalSubmit } from "components/common";
import { Modal, Row, Col } from "components/bootstrap";
import useRepositories from "./hooks/useRepositories";
const FileSystemRepositoryModalForm = ({ hideModal }) => {
  const { fsPaths, onCreateRepository } = useRepositories();
  const buildOptions = () => fsPaths.data.map((fsPath) => ({
    value: fsPath,
    label: fsPath
  }));
  const handleSubmit = (values) => onCreateRepository({ type: "fs", ...values }).then(() => hideModal());
  const initialValues = {
    name: "",
    location: ""
  };
  return /* @__PURE__ */ React.createElement(Formik, { onSubmit: handleSubmit, initialValues }, ({ isSubmitting, isValidating }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      type: "text",
      label: "Name",
      name: "name",
      help: "Name of your warm storage repository. Must be unique.",
      required: true
    }
  ), fsPaths.isLoading ? "Fetching locations..." : fsPaths.data && /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      type: "select",
      key: "location",
      name: "location",
      label: "Location",
      required: true,
      help: "Location of your warm storage repository"
    },
    /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("option", { key: "placeholder", value: "" }, "Select warm storage repository location"), buildOptions().map(({ value, label }) => /* @__PURE__ */ React.createElement("option", { key: value, value }, label)))
  )))), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
    ModalSubmit,
    {
      submitButtonText: "Create",
      submitLoadingText: "Creating...",
      onCancel: hideModal,
      disabledSubmit: isValidating,
      isSubmitting
    }
  ))));
};
export default FileSystemRepositoryModalForm;
